var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showExpiration)?_c('StyledExpirationBar',[_c('div',{staticClass:"status-bar"},[_c('div',{staticClass:"status-bar__label"},[_vm._v(_vm._s(_vm.$t('remains')))]),_c('div',{staticClass:"status-bar__step status-bar__step--remains"},[_vm._v(" "+_vm._s(_vm.expires)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }